import { createActionTypes } from "@helpers/redux-helpers";

export const getAllPostsBySubscriptionActionTypes = createActionTypes(
  "postsBySubscription/getAll",
);

export const setPostsBySubscriptionActionType = "postsBySubscription/setPosts";

export const getPostsBySubscriptionActionTypes = createActionTypes(
  "postsBySubscription/get",
);

export const getMorePostsBySubscriptionActionTypes = createActionTypes(
  "postsBySubscription/getMore",
);

export const getSibilingPostsInSubscroptionActionTypes = createActionTypes(
  "postsBySubscription/getSiblings",
);
